import React from "react";
import { AppBar, Box, Link, Toolbar, Typography } from "@mui/material";
import Logo from '../../assets/image/jeisys_logo.svg';

const TopMenu: React.FC = () => {
  return (
    <AppBar component="nav" position={"static"} style={{ background: "#fff" }}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <Link href="/">
            <img src={Logo} style={{ width: 100 }} />
          </Link>
        </Typography>
        <Box sx={{ m: 2 }}>
          <Link href="/" underline={"none"}>
            Main
          </Link>
        </Box>
        <Box sx={{ m: 2 }}>
          <Link href="/advice" underline={"none"}>
            Summary
          </Link>
        </Box>
        <Box sx={{ m: 2 }}>
          <Link href="/timeline" underline={"none"}>
            Timeline
          </Link>
        </Box>
        <Box sx={{ m: 2 }}>
          <Link href="/mypage" underline={"none"}>
            MyPage
          </Link>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopMenu;
